<template>
  <div class="is-flex is-justify-content-space-between">
    <div class="sticky" style="min-width: 600px; top: 0; overflow-y: auto">
      <InternalNotes
        :payload="payload.data"
        :additional_data="{ resource_type: payload.resource_type, showAutomatedNotes: false }"
        :is_modal="false"
        :eager_load="true" />
    </div>
    <div class="horizontal_space"></div>
    <div class="horizontal_space"></div>
    <div class="horizontal_space"></div>
    <div class="full_width">
      <div class="vertical_space"></div>
      <div class="relative is-flex is-justify-content-center is-justify-content-space-between">
        <div></div>
        <div class="is-flex is-flex-direction-column is-align-items-center">
          <div class="is-flex is-align-items-center mb-2">
            <PhoneCallButton :payload="{ resource_id: payload.data.resource_id }" />
          </div>
          <a v-if="!timingForm" @click="showTimingForm" dir="rtl" class="button is-info">קבע מועד חדש ל- Follow Up</a>
          <div v-else class="is-flex is-flex-direction-column">
            <Snooze v-model="selectedTiming" :selected_date="selectedTiming" />
            <a @click="changeTiming()" class="button is-info timing_submit_button" :class="{ 'is-loading': isChangingTiming }"> Submit </a>
          </div>
        </div>
      </div>
      <div class="vertical_space"></div>
      <div class="is-flex is-flex-direction-row-reverse">
        <div>
          <a @click="doneAlert" class="button is-info is-outlined">Done</a>
        </div>
      </div>
      <div dir="ltr" class="is-flex is-justify-content-center" style="margin-top: 30px">
        <div v-if="isLoading" class="loading"></div>
        <p v-if="!isLoading && positions.length == 0">NO HOT POSITIONS.</p>
      </div>
      <div v-for="position in positions" :key="position.id" class="alert_container">
        <div class="columns">
          <div class="column">
            <GhanaFlag :payload="position" :additional_data="{ resource_type: 'Position' }" />
          </div>
          <div class="column">
            <Message
              :payload="position"
              :additional_data="{ resource_type: 'Position', endpoint: '/positions/', headers: 'admin_headers' }"></Message>
          </div>
          <div class="column">
            <LinkEntity :payload="position" :additional_data="{ center: true, resource_type: 'Position' }" />
          </div>
        </div>
      </div>
      <div class="vertical_space"></div>
      <div class="vertical_space"></div>
    </div>
  </div>
</template>
<script>
import InternalNotes from '@/components/InternalNotes'
import GhanaFlag from '@/components/GhanaFlag'
import LinkEntity from '@/components/LinkEntity'
import Message from '@/components/Message'
import Snooze from '@/components/Snooze'
import PhoneCallButton from '@/components/PhoneCallButton'

export default {
  name: 'companyAlertsForm',
  components: {
    InternalNotes,
    GhanaFlag,
    Message,
    LinkEntity,
    Snooze,
    PhoneCallButton
  },
  props: ['payload'],
  data () {
    return {
      positions: [],
      alert: null,
      isLoading: true,
      timingForm: false,
      isChangingTiming: false,
      selectedTiming: undefined
    }
  },
  created () {
    this.getPositions()
  },
  methods: {
    getPositions () {
      this.$network_utils
        .getCompanyPositions({
          current_company_id: this.payload.data.resource_id,
          is_hot: true
        })
        .then((response) => {
          this.isLoading = false
          this.positions = Array.isArray(response) ? response : [response]
          this.$network_utils.getAllAlerts({
            current_resource_type: 'Company',
            current_resource_id: this.payload.data.resource_id,
            designators: 'follow_up_companies'
          }).then(r => {
            this.alert = r.reverse()[0]
          })
        })
    },
    async doneAlert () {
      if (!this.alert) return
      await this.$network_utils.updateAlert({ id: this.alert.id, status: 'done' })
    },
    showTimingForm () {
      this.timingForm = true
    },
    async changeTiming () {
      if (this.selectedTiming == undefined) {
        this.$utils.emit('show_toast', { text: 'תאריך לא בחור' })
        return
      }
      this.$network_utils.postStat({
        title: 'new internal note',
        designator: 'internal_notes',
        content: `All Alerts Changed Timing To <b>${new Date(this.selectedTiming).toLocaleString()}</b>`,
        status: 'done',
        owner: this.$utils.getOwner().name,
        priority: 4,
        resource_type: this.payload.data.resource_type,
        resource_id: this.payload.data.resource_id
      })
      this.isChangingTiming = true
      if (this.alert) {
        await this.$network_utils.updateAlert({ id: this.alert.id, status: 'active', timing: this.selectedTiming })
      } else {
        this.alert = await this.$network_utils.postAlert({
          designator: 'follow_up_companies',
          minimum_permission: 1,
          resource_type: 'Company',
          resource_id: this.payload.data.resource_id,
          timing: this.selectedTiming
        })
      }
      this.isChangingTiming = false
      this.$utils.emit('show_toast', { text: 'שונה בהצלחה' })
    }
  }
}
</script>
<style>
.alert_container {
  width: 100%;
  border-radius: 4px;
  margin-top: 10px;
  padding: 12px;
  border-style: solid;
  border-width: 2px;
  background-color: rgba(0, 0, 0, 0.07);
}
.alert_title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  padding-bottom: 10px;
}
.timing_submit_button {
  margin-top: 20px;
}
</style>
